import { useGetTermsRecordsQuery } from 'data/__generated__';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';

import { termsRecordsColumns, type TermsRecordRow } from '../constants/termsRecordsColumns';

export const TermsRecordsList = () => {
    const {
        loading: termsLoading,
        data: termsData,
        error: termsError,
    } = useGetTermsRecordsQuery({ fetchPolicy: 'network-only' });

    if (termsLoading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (!termsData || termsError) {
        throw new Error('Une erreur est survenue lors du chargement des CGV');
    }

    const { termsRecords } = termsData;

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<TermsRecordRow>
                columns={termsRecordsColumns}
                data={termsRecords}
                filterMode="client"
                getRowId={(row) => row._id}
            />
        </div>
    );
};
